module.exports = __webpack_public_path__ + "static/media/20210403_202314_566_IMG_0054.81db3efc.jpg";